export const styles = {
  pillSelect: (bgColor: string, textColor: string) => ({
    borderRadius: "999px",
    backgroundColor: bgColor,
    color: textColor,
    fontSize: 14,
    ".MuiOutlinedInput-notchedOutline": { border: "none" },
    ".MuiSelect-select": { py: "6px", pl: "12px", borderRadius: "999px" },
    ".MuiSelect-icon": { color: textColor, right: 10 },
    "&:hover": { backgroundColor: bgColor },
  }),
  pillSelectMenu: {
    p: "0 !important",
    mt: 0.5,
    borderRadius: 2,
  },
};
